<template>
  <div id='bd-todo-aside'>
    <div class="todo-search">
      <el-button style="float: left;" size="mini" icon="el-icon-plus" circle @click="showCreateTodoDialog()"></el-button>
      <el-input style="width: 70%;" size="mini" :placeholder="searchTip" suffix-icon="el-icon-search" v-model="search" clearable></el-input>
      <el-button style="float: right;" size="mini" icon="el-icon-refresh" circle @click="refreshData()"></el-button>
    </div>
    <div style="height: calc(100% - 60px); overflow-y: auto;">
      <li v-for="todo in filterdTodos" :key="todo.tid" class="list-item"
        :class="{ ' active': todo.tid === userCurrentTodo.tid }"
        @click="selectTodo(todo)">
        <div class="list-right">
          <div class="top">
            <span class="nickname">{{ todo.title }}
            </span>
            <span v-if="!isOutDated(todo)" class="timestamp">
              {{ todo.timestamp | time }}
            </span>
            <span v-if="isOutDated(todo)" class="timestamp" style="color: red;">
              {{ todo.timestamp | time }}
            </span>
          </div>
          <div class="bottom">
            <span class="content">
              {{ todo.content }}
              <span v-if="isOutDated(todo)" style="color: red;">【已过期】</span>
            </span>
          </div>
        </div>
      </li>
      <el-skeleton v-if="isLoading" animated/>
      <el-empty v-if="filterdTodos.length === 0 && !isLoading" description="空"></el-empty>
    </div>
    <el-dialog v-dialogDrag
      :title="createTodoTip"
      :visible.sync="createTodoDialogVisible"
      width="550"
      center>
      <el-form :model="todo" :rules="rules" label-width="90px">
        <el-form-item :label="titleTip">
          <el-input v-model="todo.title" :placeholder="titleTip"></el-input>
        </el-form-item>
        <el-form-item :label="contentTip">
          <el-input type="textarea" :autosize="{ minRows: 4, maxRows: 8}" v-model="todo.content"></el-input>
        </el-form-item>
        <el-form-item :label="attachmentsTip">
          <!-- TODO: 附件 -->
          <el-upload class='bd-upload-file'
            :on-preview='handlePreview'
            :on-remove='handleRemove'
            :before-remove='beforeRemove'
            multiple
            :limit="6"
            :on-exceed='handleExceed'
            :file-list='uploadedFileList'
            :data='upload_data'
            :name='upload_name'
            :action='uploadFileServerUrl'
            :on-success='handleFileUploadSuccess'
            :before-upload='beforeFileUpload'>
              <el-button size="small" type="primary">{{ $t('upload') }}</el-button>
              <div slot="tip" class="el-upload__tip">{{ $t('noExceed6file') }}</div>
          </el-upload>
        </el-form-item>
        <el-form-item label="到期时间">
          <el-date-picker
            v-model="todo.timestamp"
            type="datetime"
            placeholder="选择日期时间"
            default-time="12:00:00">
          </el-date-picker>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="mini" @click="createTodoDialogVisible = false">{{ $t('cancel') }}</el-button>
        <el-button size="mini" type="primary" @click="doSendTodo">{{ $t('ok') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import * as https from '@/apis/http'
import bus from '@/util/eventbus'
const constants = require('@/util/constants')

export default {
  name: 'bd-todo-aside',
  data () {
    return {
      search: '',
      createTodoDialogVisible: false,
      //
      todo: {
        id: 0,
        tid: '',
        title: '',
        content: '',
        attachments: [],
        timestamp: ''
      },
      pageParam: {
        page: 0,
        size: 100
      },
      //
      isUpdate: false,
      //
      rules: {
        title: [
          { required: true, message: '请输入标题', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '请输入内容', trigger: 'blur' }
        ]
      },
      // 上传图片相关参数
      upload_headers: {
        'X-CSRF-TOKEN': '',
        'X-Requested-With': 'XMLHttpRequest',
        'Accept': 'application/json',
        'Authorization': 'Bearer '
      },
      upload_data: {
        file_name: 'test.png',
        username: ''
      },
      upload_name: 'file',
      // 接收图片服务器地址
      uploadFileServerUrl: constants.UPLOAD_FILE_URL,
      // 上传图片结果集, 格式：{name: '', url: ''}
      uploadedFileList: [],
      uploadFileType: '',
      //
      isLoading: true,
      loadingWidget: ""
    }
  },
  computed: {
    ...mapGetters([ 'userCurrentTodo', 'userTodos' ]),
    searchTip () {
      return this.$t('search')
    },
    createTodoTip () {
      return this.$t('createTodo')
    },
    titleTip () {
      return this.$t('title')
    },
    contentTip () {
      return this.$t('content')
    },
    attachmentsTip () {
      return this.$t('attachments')
    },
    todoTypeTip () {
      return this.$t('todoType')
    },
    todoWorkGroupTip () {
      return this.$t('todoWorkGroup')
    },
    todoAgentTip () {
      return this.$t('todoAgent')
    },
    filterdTodos () {
      return this.userTodos.filter(todo => {
        return todo.title.includes(this.search)
      })
    }
  },
  methods: {
    //
    ...mapActions('mqtt', [ 'sendTodoProtobuf' ]),
    ...mapActions([ 'updateCurrentTodo', 'getTodos', 'createTodo', 'updateTodo', 'deleteTodo' ]),
    isOutDated (todo) {
      let now = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      let endAt = moment(todo.timestamp).format('YYYY-MM-DD HH:mm:ss')
      if (now > endAt) {
        return true
      }
      return false
    },
    refreshData () {
      this.myTodos()
    },
    showCreateTodoDialog () {
      //
      this.isUpdate = false
      this.createTodoDialogVisible = true
    },
    doSendTodo () {
      if (this.todo.title.length === 0) {
        this.$message({ message: '标题不能为空', type: 'warning' })
        return
      }
      if (this.todo.content.length === 0) {
        this.$message({ message: '内容不能为空', type: 'warning' })
        return
      }
      if (this.todo.timestamp.length === 0) {
        this.$message({ message: '时间不能为空', type: 'warning' })
        return
      }
      //
      this.todo.attachments = []
      for (let i = 0; i < this.uploadedFileList.length; i++) {
        const element = this.uploadedFileList[i]
        this.todo.attachments.push(element.url)
      }
      // 检测时间戳 是否选择当前时间之前
      let now = moment(new Date()).format('YYYY-MM-DD HH:mm:ss')
      let endAt = moment(this.todo.timestamp).format('YYYY-MM-DD HH:mm:ss')
      if (now > endAt) {
        this.$message({ message: '选择时间请务必在当前时间之后', type: 'warning' })
        return
      }
      this.todo.timestamp = endAt
      //
      if (this.isUpdate) {
        this.updateTodo(this.todo)
      } else {
        this.createTodo(this.todo)
      }
      this.createTodoDialogVisible = false
      //
    },
    /**
     * 上传图片相关函数
     */
    handleRemove (file, uploadedFileList) {
      console.log(file, uploadedFileList)
      // 删除
      for (var i = 0; i < this.uploadedFileList.length; i++) {
        if (this.uploadedFileList[i].name === file.name) {
          this.uploadedFileList.splice(i, 1)
        }
      }
    },
    handlePreview (file) {
      console.log(file)
    },
    handleExceed (files, uploadedFileList) {
      this.$message.warning(`当前限制选择 6 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + uploadedFileList.length} 个文件`)
    },
    beforeRemove (file, uploadedFileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    beforeFileUpload (file) {
      // file.name包含文件后缀
      // TODO: 给文件名增加前缀，避免重复
      this.upload_data.file_name = file.name
      // 文件大小控制在2m之内
      this.uploadFileType = file.type
      const isLt10M = file.size / 1024 / 1024 < 10
      return isLt10M
    },
    handleFileUploadSuccess (result, file) {
      // console.log('upload file success result:', result, ' file:', file)
      if (result.status_code === 200) {
        let url = result.data
        this.uploadedFileList.push({ name: file.name, url: url })
      } else {
        this.$message.error('上传文件错误，请稍后重试...')
      }
    },
    selectTodo (todo) {
      this.updateCurrentTodo(todo)
    },
    myTodos () {
      // 首先清空
      let payload = { page: this.pageParam.page, size: this.pageParam.size }
      this.getTodos(payload)
      // https://element.eleme.cn/#/zh-CN/component/loading
      // this.loadingWidget = this.$loading({
      //   // target: 'bd-message',
      //   lock: false,
      //   fullscreen: false,
      //   text: "Loading",
      //   spinner: "el-icon-loading",
      //   background: "rgba(0, 0, 0, 0.7)",
      // });
    }
  },
  created () {
    //
  },
  mounted () {
    this.refreshData()
    // 监听创建待办任务
    bus.$on(constants.EVENT_BUS_CREATE_TODO, message => {
      this.isUpdate = false
      this.createTodoDialogVisible = true
    })
    // 监听编辑更新待办任务
    bus.$on(constants.EVENT_BUS_UPDATE_TODO, message => {
      this.isUpdate = true
      this.todo = this.userCurrentTodo
      this.createTodoDialogVisible = true
    })
    // 监听删除待办任务
    bus.$on(constants.EVENT_BUS_DELETE_TODO, message => {
      //
      this.todo = this.userCurrentTodo
      // 弹窗确认
      this.$confirm(this.$t('deleteToDoAsure'), this.$t('tip'), {
          confirmButtonText: this.$t('ok'),
          cancelButtonText: this.$t('cancel'),
          type: 'warning'
        }).then(() => {
          // 执行删除
          this.deleteTodo(this.todo)
        }).catch(() => {
          // 取消删除
        })
    })
    //
    let app = this
    bus.$on(constants.EVENT_BUS_TODO_LOADED, () => {
      app.isLoading = false
      if (app.loadingWidget) {
        app.loadingWidget.close()
      }
    })
  },
  filters: {
    // 将日期过滤为 hour:minutes
    time (value) {
      if (typeof value === 'string') {
        return moment(value).format('MM-DD HH:mm:ss')
      } else {
        return value
      }
    }
  }
}
</script>

<style scoped>
#bd-todo-aside {
  width: 100%;
  height: 100%;
  float: left;
}
.todo-search {
  padding: 12px 12px 12px 12px;
}
.list-item {
  padding: 5px 5px 5px 5px;
  margin-bottom: 0px;
  border-bottom: 1px solid beige;
  height: 50px;
}
.list-item:hover {
  background-color: rgb(220,220,220)
}
.active {
  background-color:darkkhaki
}
.list-item .avatar {
  border-radius: 2px;
  margin-right: 2px;
}
li {
  list-style: none;
}
.list-left {
  margin-top: 4px;
  margin-left: 2px;
  width: 25px;
  height: 25px;
  float: left;
}
.list-right {
  margin-left: 12px;
}
.list-right .top {
  margin-top: 2px;
  text-align: left;
}
span.nickname {
  display: inline-block;
  vertical-align: top;
  font-size: 14px;
  width: calc(100% - 100px);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
span.timestamp {
  float: right;
  color:gray;
  font-size: 12px;
  vertical-align: top;
  width: 85px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.list-right .bottom {
  width: 0%;
  text-align: left;
}
.list-right .bottom-queue {
  width: 90%;
  text-align: left;
}
.list-right .bottom .content{
  font-size: 12px;
  width: 150px;
  height: 100%;
  color: gray;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.list-right .unreadCount {
    margin-top: 4px;
    float: right;
    font-size: 10px;
    width: 12px;
    height: 12px;
    line-height: 12px;
    text-align: center;
    border-radius:5px;
    color: white;
    background-color: red;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.el-form {
  margin-bottom: 0px;
}
</style>
